import { IconButton } from '@nexelem/components';
import { ProLightPen } from '@nexelem/icons/ProLightPen';
import { ProLightEye } from '@nexelem/icons/ProLightEye';
import clsx from 'clsx';
import { ProSolidEye } from '@nexelem/icons/ProSolidEye';
import { QueueStored, useGroupedQueuesStore } from '../../../store';
import { openQueueDetailsModal } from '../../../modals';

type SettingsQueueProps = {
  queue: QueueStored;
};

export const SettingsQueue = ({ queue }: SettingsQueueProps) => {
  const toggleDraftVisibility = useGroupedQueuesStore((state) => state.toggleQueueDraftVisibility);

  const {
    name,
    isHidden,
    id = 0,
    area: { id: queueGroupId = 0 },
    shortName,
  } = queue;

  const handleOpenModal = () => openQueueDetailsModal({ queue });
  const toggle = () => toggleDraftVisibility(queueGroupId, id);

  return (
    // DndSortableQueue.tsx apply styles based on .hidden-queue class
    <div
      className={clsx(
        'inline-flex grow items-center gap-2 overflow-hidden rounded-xs',
        isHidden ? 'hidden-queue text-text-secondary-darker' : 'text-text-action',
      )}
    >
      <span className="my-2 line-clamp-2 text-t16-sb">
        ({shortName}) {name}
      </span>
      <div className="ml-auto flex flex-nowrap">
        <IconButton Icon={ProLightPen} size="small" onClick={handleOpenModal} />
        <IconButton
          className={clsx(isHidden ? 'text-text-secondary-darker' : 'text-text-focus')}
          Icon={isHidden ? ProLightEye : ProSolidEye}
          size="small"
          onClick={toggle}
        />
      </div>
    </div>
  );
};
